export const CSS = {
  container: "container",
};
